import {
  SET_MENU_OPTIONS,
  EPG_SET_CURRENT_CHANNEL,
  EPG_SET_CURRENT_EVENT,
  EPG_CLEAR_CHANNEL_EVENT,
  SET_EVENT_FROM_EPG,
} from '../actions/liveMenu/constants';

const initialState = {
  step: 'main',
  channel: null,
  event: null,
  eventFromEpg: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_MENU_OPTIONS:
      return { ...state, step: action.payload };
    case EPG_SET_CURRENT_CHANNEL:
      return { ...state, channel: action.payload };
    case EPG_SET_CURRENT_EVENT:
      return { ...state, event: action.payload };
    case EPG_CLEAR_CHANNEL_EVENT:
      return { ...state, channel: null, event: null, eventFromEpg: null };
    case SET_EVENT_FROM_EPG:
      return { ...state, eventFromEpg: action.payload };
    default:
      return { ...state };
  }
};
